import { render, staticRenderFns } from "./CertificateSelect.html?vue&type=template&id=28c892e6&scoped=true&"
import script from "./CertificateSelect.vue?vue&type=script&lang=js&"
export * from "./CertificateSelect.vue?vue&type=script&lang=js&"
import style0 from "./CertificateSelect.scss?vue&type=style&index=0&id=28c892e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c892e6",
  null
  
)

export default component.exports